import { render, staticRenderFns } from "./applicant_random_dialog.vue?vue&type=template&id=0971d008&scoped=true"
import script from "./applicant_random_dialog.vue?vue&type=script&lang=ts"
export * from "./applicant_random_dialog.vue?vue&type=script&lang=ts"
import style0 from "./applicant_random_dialog.vue?vue&type=style&index=0&id=0971d008&prod&lang=scss&scoped=true"
import style1 from "./applicant_random_dialog.vue?vue&type=style&index=1&id=0971d008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0971d008",
  null
  
)

export default component.exports